var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-layout', {
    attrs: {
      "justify-center": ""
    }
  }, [_c('v-responsive', {
    staticClass: "px-1",
    attrs: {
      "max-width": "1140px",
      "width": "100%",
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "headline text-start mt-8"
  }, [_c('span', [_vm._v("교육소개")])]), _c('section', {
    staticClass: "mt-4"
  }, [_c('v-layout', [_c('span', {
    staticClass: "subtitle-2 font-weight-bold"
  }, [_vm._v("유튜브 링크")])]), _c('v-card', [_c('v-card-text', {
    staticClass: "d-flex"
  }, [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "small": "",
      "color": "primary"
    },
    on: {
      "click": function click($event) {
        return _vm.$set(_vm.festa.youtubeLink, _vm.festa.youtubeLink.length, {});
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "size": "18"
    }
  }, [_vm._v("mdi-plus")]), _vm._v("추가")], 1)], 1), _vm._l(_vm.festa.youtubeLink, function (item, index) {
    return [_c('v-divider', {
      key: 'divider' + index
    }), _c('v-row', {
      key: index,
      staticClass: "px-4",
      attrs: {
        "align": "center"
      }
    }, [_c('v-col', {
      attrs: {
        "cols": "10"
      }
    }, [_c('v-textarea', {
      attrs: {
        "dense": "",
        "hide-details": "",
        "outlined": "",
        "rows": "1"
      },
      model: {
        value: item.title,
        callback: function callback($$v) {
          _vm.$set(item, "title", $$v);
        },
        expression: "item.title"
      }
    })], 1), _c('v-col', {
      attrs: {
        "cols": "auto"
      }
    }, [_c('v-btn', {
      attrs: {
        "small": "",
        "outlined": "",
        "color": "red"
      },
      on: {
        "click": function click($event) {
          return _vm.festa.youtubeLink.splice(index, 1);
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "size": "18"
      }
    }, [_vm._v("mdi-delete-outline")]), _vm._v("삭제")], 1)], 1)], 1)];
  })], 2)], 1), _c('section', {
    staticClass: "mt-4"
  }, [_c('v-layout', [_c('span', {
    staticClass: "subtitle-2 font-weight-bold"
  }, [_vm._v("프로그램 및 커리큘럼")])]), _c('v-card', [_c('v-card-text', {
    staticClass: "d-flex"
  }, [_c('v-spacer'), _vm.festa.section2.length < 4 ? _c('v-btn', {
    attrs: {
      "small": "",
      "color": "primary"
    },
    on: {
      "click": function click($event) {
        return _vm.$set(_vm.festa.section2, _vm.festa.section2.length, {
          name: null,
          items: [],
          curriculums: [{
            subtitles: [{
              items: []
            }]
          }],
          links: []
        });
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "size": "18"
    }
  }, [_vm._v("mdi-plus")]), _vm._v("추가")], 1) : _vm._e()], 1), _vm._l(_vm.festa.section2, function (section, index) {
    return [_c('v-divider', {
      key: 'divider' + index
    }), _c('v-col', {
      key: index,
      staticClass: "text-h6 font-weight-bold"
    }, [_vm._v("프로그램")]), _c('v-row', {
      key: index,
      staticClass: "px-4",
      attrs: {
        "align": "center"
      }
    }, [_c('v-col', {
      attrs: {
        "cols": "6"
      }
    }, [_c('v-textarea', {
      attrs: {
        "placeholder": "커리큘럼 명칭을 입력해주세요",
        "dense": "",
        "hide-details": "",
        "outlined": "",
        "rows": "1"
      },
      model: {
        value: section.name,
        callback: function callback($$v) {
          _vm.$set(section, "name", $$v);
        },
        expression: "section.name"
      }
    })], 1), _c('v-col', {
      attrs: {
        "cols": "auto"
      }
    }, [_c('v-btn', {
      attrs: {
        "small": "",
        "outlined": "",
        "color": "red"
      },
      on: {
        "click": function click($event) {
          return _vm.festa.section2.splice(index, 1);
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "size": "18"
      }
    }, [_vm._v("mdi-delete-outline")]), _vm._v("삭제")], 1), _c('v-btn', {
      attrs: {
        "small": "",
        "color": "primary"
      },
      on: {
        "click": function click($event) {
          return _vm.$set(section.items, section.items.length, {});
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "left": "",
        "size": "18"
      }
    }, [_vm._v("mdi-plus")]), _vm._v("프로그램 추가")], 1), _c('v-btn', {
      attrs: {
        "small": "",
        "color": "primary"
      },
      on: {
        "click": function click($event) {
          return _vm.$set(section.curriculums, section.curriculums.length, {});
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "left": "",
        "size": "18"
      }
    }, [_vm._v("mdi-plus")]), _vm._v("커리큘럼 추가")], 1), _c('v-btn', {
      attrs: {
        "small": "",
        "color": "primary"
      },
      on: {
        "click": function click($event) {
          return _vm.$set(section.links, section.links.length, {
            title: null
          });
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "left": "",
        "size": "18"
      }
    }, [_vm._v("mdi-plus")]), _vm._v("유튜브 링크 추가")], 1)], 1)], 1), _c('v-col', {
      key: index,
      staticClass: "text-h6 font-weight-bold"
    }, [_vm._v("프로그램 항목")]), _vm._l(section.items, function (item, index1) {
      return [_c('v-divider', {
        key: 'divider' + index1
      }), _c('v-row', {
        key: index1,
        staticClass: "px-4",
        attrs: {
          "align": "center"
        }
      }, [_c('v-col', {
        attrs: {
          "cols": "2"
        }
      }, [_c('v-textarea', {
        attrs: {
          "placeholder": "프로그램 타이틀을 입력해주세요",
          "dense": "",
          "hide-details": "",
          "outlined": "",
          "rows": "1"
        },
        model: {
          value: item.title,
          callback: function callback($$v) {
            _vm.$set(item, "title", $$v);
          },
          expression: "item.title"
        }
      })], 1), _c('v-col', [_c('v-textarea', {
        attrs: {
          "placeholder": "프로그램 내용을 입력해주세요",
          "hide-details": "",
          "outlined": "",
          "rows": "2"
        },
        model: {
          value: item.txt,
          callback: function callback($$v) {
            _vm.$set(item, "txt", $$v);
          },
          expression: "item.txt"
        }
      })], 1), _c('v-col', {
        attrs: {
          "cols": "auto"
        }
      }, [_c('v-btn', {
        attrs: {
          "small": "",
          "outlined": "",
          "color": "red"
        },
        on: {
          "click": function click($event) {
            return section.items.splice(index1, 1);
          }
        }
      }, [_c('v-icon', {
        attrs: {
          "size": "18"
        }
      }, [_vm._v("mdi-delete-outline")]), _vm._v("삭제")], 1)], 1)], 1)];
    }), _vm._l(section.curriculums, function (curriculum, index2) {
      return [_c('v-divider', {
        key: 'divider' + index2
      }), _c('v-col', {
        key: index2,
        staticClass: "text-h6 font-weight-bold"
      }, [_vm._v("커리큘럼 대제목")]), _c('v-row', {
        key: index2,
        staticClass: "px-4",
        attrs: {
          "align": "center"
        }
      }, [_c('v-col', {
        attrs: {
          "cols": "8"
        }
      }, [_c('v-textarea', {
        attrs: {
          "placeholder": "대제목을 입력해주세요",
          "dense": "",
          "hide-details": "",
          "outlined": "",
          "rows": "1"
        },
        model: {
          value: curriculum.title,
          callback: function callback($$v) {
            _vm.$set(curriculum, "title", $$v);
          },
          expression: "curriculum.title"
        }
      })], 1), _c('v-col', {
        attrs: {
          "cols": "auto"
        }
      }, [_c('v-btn', {
        attrs: {
          "small": "",
          "color": "primary"
        },
        on: {
          "click": function click($event) {
            return _vm.$set(curriculum.subtitles, curriculum.subtitles.length, {
              title: null,
              items: []
            });
          }
        }
      }, [_c('v-icon', {
        attrs: {
          "left": "",
          "size": "18"
        }
      }, [_vm._v("mdi-plus")]), _vm._v("소제목 추가")], 1), _c('v-btn', {
        attrs: {
          "small": "",
          "outlined": "",
          "color": "red"
        },
        on: {
          "click": function click($event) {
            return section.curriculums.splice(index2, 1);
          }
        }
      }, [_c('v-icon', {
        attrs: {
          "size": "18"
        }
      }, [_vm._v("mdi-delete-outline")]), _vm._v("삭제")], 1)], 1)], 1), _vm._l(curriculum.subtitles, function (subtitle, index3) {
        return [_c('v-divider', {
          key: 'divider' + index3
        }), _c('v-col', {
          key: index3,
          staticClass: "text-h6 font-weight-bold"
        }, [_vm._v("커리큘럼 소제목")]), _c('v-row', {
          key: index3,
          staticClass: "px-4",
          attrs: {
            "align": "center"
          }
        }, [_c('v-col', {
          attrs: {
            "cols": "8"
          }
        }, [_c('v-textarea', {
          attrs: {
            "placeholder": "소제목을 입력해주세요",
            "dense": "",
            "hide-details": "",
            "outlined": "",
            "rows": "1"
          },
          model: {
            value: subtitle.title,
            callback: function callback($$v) {
              _vm.$set(subtitle, "title", $$v);
            },
            expression: "subtitle.title"
          }
        })], 1), _c('v-col', {
          attrs: {
            "cols": "auto"
          }
        }, [_c('v-btn', {
          attrs: {
            "small": "",
            "color": "primary"
          },
          on: {
            "click": function click($event) {
              return _vm.$set(subtitle.items, subtitle.items.length, {});
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "left": "",
            "size": "18"
          }
        }, [_vm._v("mdi-plus")]), _vm._v("항목 추가")], 1), _c('v-btn', {
          attrs: {
            "small": "",
            "outlined": "",
            "color": "red"
          },
          on: {
            "click": function click($event) {
              return curriculum.subtitles.splice(index3, 1);
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "size": "18"
          }
        }, [_vm._v("mdi-delete-outline")]), _vm._v("삭제")], 1)], 1)], 1), _c('v-col', {
          key: index3,
          staticClass: "text-h6 font-weight-bold"
        }, [_vm._v("커리큘럼 소제목 항목")]), _vm._l(subtitle.items, function (item, index4) {
          return [_c('v-divider', {
            key: 'divider' + index4
          }), _c('v-row', {
            key: index4,
            staticClass: "px-4",
            attrs: {
              "align": "center"
            }
          }, [_c('v-col', {
            attrs: {
              "cols": "10"
            }
          }, [_c('v-textarea', {
            attrs: {
              "placeholder": "소제목에 항목을 입력해주세요",
              "dense": "",
              "hide-details": "",
              "outlined": "",
              "rows": "1"
            },
            model: {
              value: item.title,
              callback: function callback($$v) {
                _vm.$set(item, "title", $$v);
              },
              expression: "item.title"
            }
          })], 1), _c('v-col', {
            attrs: {
              "cols": "auto"
            }
          }, [_c('v-btn', {
            attrs: {
              "small": "",
              "outlined": "",
              "color": "red"
            },
            on: {
              "click": function click($event) {
                return subtitle.items.splice(index4, 1);
              }
            }
          }, [_c('v-icon', {
            attrs: {
              "size": "18"
            }
          }, [_vm._v("mdi-delete-outline")]), _vm._v("삭제")], 1)], 1)], 1)];
        })];
      }), _vm._l(section.links, function (link, index) {
        return [_c('v-divider', {
          key: 'divider' + index
        }), _c('v-row', {
          key: index,
          staticClass: "px-4",
          attrs: {
            "align": "center"
          }
        }, [_c('v-col', {
          attrs: {
            "cols": "10"
          }
        }, [_c('v-textarea', {
          attrs: {
            "placeholder": "유튜브 링크를 입력해주세요",
            "dense": "",
            "hide-details": "",
            "outlined": "",
            "rows": "1"
          },
          model: {
            value: link.title,
            callback: function callback($$v) {
              _vm.$set(link, "title", $$v);
            },
            expression: "link.title"
          }
        })], 1), _c('v-col', {
          attrs: {
            "cols": "auto"
          }
        }, [_c('v-btn', {
          attrs: {
            "small": "",
            "outlined": "",
            "color": "red"
          },
          on: {
            "click": function click($event) {
              return section.links.splice(index, 1);
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "size": "18"
          }
        }, [_vm._v("mdi-delete-outline")]), _vm._v("삭제")], 1)], 1)], 1)];
      }), [_c('v-divider'), _c('v-row', {
        staticClass: "px-4",
        attrs: {
          "align": "center"
        }
      }, [_c('v-col', {
        attrs: {
          "cols": "10"
        }
      }, [_c('v-textarea', {
        attrs: {
          "placeholder": "교육접수 링크를 입력해주세요",
          "dense": "",
          "hide-details": "",
          "outlined": "",
          "rows": "1"
        },
        model: {
          value: section.link,
          callback: function callback($$v) {
            _vm.$set(section, "link", $$v);
          },
          expression: "section.link"
        }
      })], 1), _c('v-col', {
        attrs: {
          "cols": "auto"
        }
      })], 1)]];
    })];
  })], 2)], 1), _c('v-row', {
    staticClass: "mx-1 my-4",
    attrs: {
      "justify": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "md": "auto",
      "sm": "auto"
    }
  }, [_c('v-btn', {
    attrs: {
      "dark": "",
      "color": "blue darken-2",
      "elevation": "4"
    },
    on: {
      "click": function click($event) {
        return _vm.save();
      }
    }
  }, [_vm._v("저장")])], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }